import { Injectable } from '@angular/core';
import { EventHoveringArg } from '@fullcalendar/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { TranslatorService } from '@sc/data-access-translation';
import { GenericEventExtendedProps } from '@sc/feature-fitter-shared-libs';
import { dayjs } from '@sc/utils';
import { capitalize } from 'lodash-es';
import { PlanningCalendarService } from '../../planning-calendar.service';
import { AbstractTooltipService } from './abstract-tooltip.service';

@Injectable({ providedIn: 'root' })
export class TooltipGenericEventService extends AbstractTooltipService {
  constructor(
    protected planningCalendarService: PlanningCalendarService,
    protected configurationService: ConfigurationService,
    private readonly translator: TranslatorService
  ) {
    super(planningCalendarService, configurationService);
  }

  generateToolTip(info: EventHoveringArg, simplified = false) {
    const extendedProps = info.event.extendedProps as GenericEventExtendedProps;

    const event = extendedProps.event;

    const start = dayjs(event.startTime).tz(event.timezone);
    const end = dayjs(event.endTime).tz(event.timezone);

    const startDay = capitalize(start.format('dddd LL'));
    const endDay = capitalize(end.format('dddd LL'));
    const startTime = start.format('LT');
    const endTime = end.format('LT');

    const resources =
      event.resources?.reduce((acc, resource) => {
        if (acc) {
          return acc + ' - ' + resource.name;
        } else {
          return resource.name;
        }
      }, '') ?? null;

    return `
      <div class="tooltip-agenda" style="border-color: #D1D2DC; background-color: #F2F5F8;">
        <p class="font-family-bold font-s">
          ${
            event.title ??
            this.translator.getInstantTranslation(
              `PlanningEventTooltip.types.${event.type}`
            )
          }
        </p>

        ${
          resources
            ? `<p class="ont-family-main font-xs uppercase">
               ${this.translator.getInstantTranslation(
                 `PlanningEventTooltip.EventResourcesLabel.${event.type}`,
                 { resources }
               )}
            </p>`
            : ''
        }

        <p class="font-family-main font-xs">
          ${
            startDay !== endDay
              ? this.translator.getInstantTranslation(
                  'PlanningEventTooltip.dateMultipleDays',
                  { startDay, startTime, endDay, endTime }
                )
              : this.translator.getInstantTranslation(
                  'PlanningEventTooltip.dateSingleDay',
                  { startDay, startTime, endTime }
                )
          }
        </p>
        <p class="font-family-main font-xs">
          <i>${event.comment?.replace('\n', '<br/>') || ''}</i>
        </p>
      </div>
    `;
  }
}
